<template>
    <marquee class="announcement-msg marquee-moving-text" v-if="config?.announcement?.value">
        {{config?.announcement?.value}}
    </marquee>
    <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { getWalletAuth} from '../services/module';

import { computed } from 'vue';
export default {
    name: "WalletModule",
     data() {
        return {
            init: false,
            config: null,
            walletData: null
        }
    },
     provide() {
        return { 
            walletConfig : computed(() => this.config),
        }
    },
    created() {
            if(!this.$auth?.user?.isDemo){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push('/')
        }
    },
    methods: {
       async getWalletAuth(){
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        }
    }
}
</script>